import API from '../../services/api';

export const GLOBAL_LIST_CATEGORY = {
  users: 'users',
  sites: 'sites',
  businessClients: 'businessClients',
  departments: 'departments',
};

export const GLOBAL_LIST = {
  [GLOBAL_LIST_CATEGORY.users]: { service: API.fetchGlobalUsers },
  [GLOBAL_LIST_CATEGORY.sites]: { service: API.fetchGlobalSites },
  [GLOBAL_LIST_CATEGORY.businessClients]: {
    service: API.fetchGlobalBusinessClients,
  },
  [GLOBAL_LIST_CATEGORY.departments]: {
    service: API.fetchGlobalDepartments,
  },
};
